<template>
    <div class="loading" :class="{ 'loading--with-message': !!message }">
        <span v-if="!!message">{{message}}</span>
        <div class="lds-ellipsis" :class="{ 'lds-ellipsis--with-message': !!message }">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            message: String,
        },
    }
</script>


<style lang="scss" scoped>
    .loading {
        &--with-message {
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;    
        }
    }
    .lds-ellipsis {
        &--with-message {
            position:relative;
            margin: 0;
        }
    }
</style>